import Refetch from '../../ui/Refetch'
import { useDispatch } from 'react-redux';
import { useMasterData } from '../../../hooks/api/useMasterData';
import { setTypeModal, setTypeOfShowModalType } from '../../../features/modal/modalSlice';

export default function ChapelOptionSorting() {

    const dispatch = useDispatch();
    const { refetchChapelsAvailable, } = useMasterData()

    const handleCreateNewChapel = () => {
        dispatch(setTypeModal('newChapel'));
        dispatch(setTypeOfShowModalType('chapelModal'))
    }

    return (
        <div className='w-full flex-1 flex-col'>
            <div className={`flex justify-between`}>
                <p className='text-sm font-medium flex items-center justify-center'>
                    Chapel Room Management
                </p>    
                <div className='flex space-x-2'>
                    {/* <button 
                        onClick={handleCreateNewChapel}
                        className='flex items-center text-sm font-medium rounded transition px-2 py-1 bg-cbColor text-white shadow-md'
                    >
                        <FluentTabNew24Filled color='#ffff' height={19} width={19}/> 
                    </button> */}
                    <Refetch refetch={refetchChapelsAvailable} size={23} btnStyle={''}/>
                </div>
            </div>
        </div>
    )
}
